import p1 from "../Assets/images/gallery/lobby.jpg";
import p2 from "../Assets/images/gallery/openview.jpg";
import p3 from "../Assets/images/gallery/Balcony1.jpg";
import p4 from "../Assets/images/General.jpg";
import p5 from "../Assets/images/WorkStation1.jpg";
import p6 from "../Assets/images/Balcony2.jpg";
import p7 from "../Assets/images/WorkStation2.jpg";
import p8 from "../Assets/images/WorkStation3.jpg";
import p9 from "../Assets/images/poolview.jpg";
import p10 from "../Assets/images/pool.jpg";
import c1 from "../Assets/images/rooms/closet1.jpg";
import r1 from "../Assets/images/rooms/room1.jpg";
import r3 from "../Assets/images/rooms/room3.jpg";
import r4 from "../Assets/images/rooms/room4.jpg";
import r5 from "../Assets/images/rooms/room5.jpg";
import r7 from "../Assets/images/rooms/room7.jpg";

export const Photos = [
  { src: p1, width: 2, height: 1 },
  { src: p2, width: 4, height: 3 },
  { src: r1, width: 4, height: 1 },
  { src: p3, width: 1, height: 3 },
  { src: p4, width: 4, height: 3 },
  { src: r3, width: 4, height: 3 },
  { src: p5, width: 5, height: 3 },
  { src: p6, width: 4, height: 3 },
  { src: r4, width: 4, height: 2 },
  { src: p7, width: 4, height: 3 },
  { src: p8, width: 5, height: 3 },
  { src: r5, width: 4, height: 4 },
  { src: p9, width: 4, height: 3 },
  { src: p10, width:3, height: 3 },
  { src: r7, width: 4, height: 4 },
  { src: c1, width: 4, height: 3 },

  //   { src: p4 },
];
